import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import FiltersHelper from '../utilities/filters.helper';
import { PPUPaginatedSuccessResponse, PPUSuccessResponse } from '../models/response.model';
import {
  ConfirmPickupCodeModel,
  PPUActivePackageModel,
  PPUActivePackagePickModel,
  PPUBypassSupervisorModel,
  PPUOrderDeliveryConfirmModel,
  PPUPaymentStatusModel,
  PPUSharePaymentDetailModel,
} from '../models/deliver-customer.model';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DeliverCustomerService {
  constructor(private http: HttpClient) {}

  public getAllActivePackages(
    ppuLocationId: number,
    searchText: string,
    page: number,
    pageSize: number,
    filters: any | null
  ): Observable<any> {
    let queryParams = new HttpParams()
      .set('PPULocationId', ppuLocationId.toString())
      .set('SearchText', searchText)
      .set('PaginatedQuery.Page', page.toString())
      .set('PaginatedQuery.PageSize', pageSize.toString());

    queryParams = FiltersHelper.getFilterParameters(filters, queryParams);

    return this.http
      .get<PPUPaginatedSuccessResponse<PPUActivePackageModel>>(
        `${environment.API_ROOT}Agent/api/v1/Package/GetAllActivePackages`,
        { params: queryParams }
      )
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public getPackagesDetails(packageIds: number[]): Observable<any> {
    return this.http
      .post<PPUPaginatedSuccessResponse<PPUActivePackagePickModel>>(
        `${environment.API_ROOT}Agent/api/v1/Package/PackagesPickupDetails`,
        { packageIds: packageIds }
      )
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public confirmDelivery(confirmDeliveryPkg: PPUOrderDeliveryConfirmModel): Observable<any> {
    return this.http
      .post<PPUSuccessResponse<PPUOrderDeliveryConfirmModel>>(
        `${environment.API_ROOT}Agent/api/v1/Order/ConfirmDelivery`,
        confirmDeliveryPkg
      )
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public verifySupervisorCode(supervisorCode: string, orderIds: number[]): Observable<any> {
    return this.http
      .post<PPUSuccessResponse<PPUBypassSupervisorModel>>(
        `${environment.API_ROOT}Agent/api/v1/Order/VerifySupervisorCode`,
        { supervisorCode: supervisorCode, orderIds: orderIds }
      )
      .pipe(
        map((res: any) => res.result),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public getPaymentStatuses(orderIds: number[]): Observable<any> {
    return this.http
      .post<PPUSuccessResponse<PPUPaymentStatusModel>>(`${environment.API_ROOT}Agent/api/v1/Order/PaymentStatuses`, {
        orderIds: orderIds
      })
      .pipe(
        map((res: any) => res.result),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public createPaymentLink(orderIds: number[]): Observable<any> {
    return this.http
      .post<PPUSuccessResponse<PPUSharePaymentDetailModel>>(
        `${environment.API_ROOT}Agent/api/v1/Order/SharePaymentDetail`,
        { orderIds: orderIds }
      )
      .pipe(
        map((res: any) => res.result),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public confirmPickupCode(confirmPickupCode: ConfirmPickupCodeModel): Observable<any> {
    return this.http
      .post<PPUSuccessResponse<boolean>>(
        `${environment.API_ROOT}Agent/api/v1/Order/ConfirmPickupCode`,
        confirmPickupCode
      )
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }
}
